import { CONSTANTS } from '../../_data/lookups.js';
import { getImmediatePreviousStep, isNaturalLessThanToolStep, readMaterializedBooleanDecision, } from './routingHelpers.js';
export function shouldSkipLoopCloneAfterFalseWhen(args) {
    const { step, threadSteps, currentStepCounter, toolMap, workflowState, } = args;
    if (step.stepKind !== CONSTANTS.Enums.StepKind.while &&
        step.stepKind !== CONSTANTS.Enums.StepKind.for) {
        return false;
    }
    const prev = getImmediatePreviousStep(threadSteps, currentStepCounter);
    if (!prev || prev.stepKind !== CONSTANTS.Enums.StepKind.tool) {
        return false;
    }
    const whenToolStep = prev;
    if (step.stepKind === CONSTANTS.Enums.StepKind.for) {
        // Deliberate invariant: ForStep whenTools must be LessThan.
        const { isNaturalLessThan } = isNaturalLessThanToolStep(whenToolStep, toolMap);
        if (!isNaturalLessThan) {
            throw new Error(`ForStep invariant violation: expected LessThan whenTool at counter ${currentStepCounter}; got '${whenToolStep.toolHandle}'`);
        }
    }
    const decision = readMaterializedBooleanDecision(workflowState, whenToolStep, toolMap);
    return !decision;
}
